export type AnchoredMenuPlacement = 'top' | 'bottom';

export function placeAnchoredMenu(input: {
  trigger: { top: number; right: number; bottom: number; left: number };
  menuWidth: number;
  menuHeight: number;
  viewportWidth: number;
  viewportHeight: number;
  align: 'start' | 'end';
  gap?: number;
  margin?: number;
}): { top: number; left: number; maxHeight: number; placement: AnchoredMenuPlacement } {
  const gap = input.gap ?? 8;
  const margin = input.margin ?? 8;
  const { trigger } = input;
  const spaceBelow = Math.max(0, input.viewportHeight - trigger.bottom - gap - margin);
  const spaceAbove = Math.max(0, trigger.top - gap - margin);
  const placement: AnchoredMenuPlacement =
    input.menuHeight <= spaceBelow || spaceBelow >= spaceAbove ? 'bottom' : 'top';
  const available = placement === 'bottom' ? spaceBelow : spaceAbove;
  const height = Math.min(input.menuHeight, available);
  const top =
    placement === 'bottom'
      ? trigger.bottom + gap
      : Math.max(margin, trigger.top - gap - height);
  const preferredLeft = input.align === 'end' ? trigger.right - input.menuWidth : trigger.left;
  const maxLeft = Math.max(margin, input.viewportWidth - input.menuWidth - margin);
  const left = Math.min(Math.max(preferredLeft, margin), maxLeft);
  return { top, left, maxHeight: available, placement };
}
